'use-client';

import { useSession } from 'next-auth/react';
import { type ButtonHTMLAttributes, useState } from 'react';
import { type ClassNameValue, twMerge } from 'tailwind-merge';

import { useModalStore } from '@/store/modal.store';
import { DonatModal } from './fanfic-page/donat-modal';
import type { TFanficAuthor } from '@/features/fanfic-page/types/fanfic';

type TDonationButtonVariants = 'small' | 'compact' | 'base';

type AvatarForButton = {
  url?: string;
  thumbnailURL?: string;
};

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  author?: Partial<Omit<TFanficAuthor, 'avatar'>> & {
    avatar?: AvatarForButton;
  };
  variant?: TDonationButtonVariants;
  fullText?: boolean;
  currentUserId?: number;
};

const buttonStyles: Record<TDonationButtonVariants, ClassNameValue> = {
  base: 'py-[10px] px-4 font-medium',
  compact: 'p-3',
  small: '!rounded-[8px] text-[10px] px-2 h-7 w-[90px]',
};
export const DonationButton = ({
  author,
  variant = 'base',
  fullText = false,
  currentUserId,
}: Props) => {
  const { data: session } = useSession();
  const { setIsOpenAuthDialog } = useModalStore();
  const [isDonatModalOpen, setIsDonatModalOpen] = useState(false);
  const hasDonationsEnabled = author?.donation?.hasCard && author?.donation?.donationUserId;

  // Check if current user is the author
  const isCurrentUserAuthor = currentUserId === author?.id;

  const handleClickButton = () => {
    if (!session?.user) {
      setIsOpenAuthDialog(true);
      return;
    }
    setIsDonatModalOpen(true);
  };

  if (!author || !hasDonationsEnabled || isCurrentUserAuthor) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        onClick={handleClickButton}
        className={twMerge(
          'bg-[#505CFF] rounded-[12px] text-white hover:opacity-90 transition-opacity flex items-center justify-center',
          buttonStyles[variant],
        )}
      >
        <span>
          Поддержать
          <span className={`${fullText ? 'sm:inline' : 'hidden'}`}> автора</span>
        </span>
      </button>
      {/* Donat Modal */}
      <DonatModal
        isOpen={isDonatModalOpen}
        onClose={() => setIsDonatModalOpen(false)}
        author={author || null}
      />
    </>
  );
};
